import axios from 'axios'
import { getToken } from '../utils/auth'

const request = axios.create({
  baseURL: '/apiadmin/Zh/',
  timeout: 30000
})

request.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.token = token
  }
  return config
})

request.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
)

export default request
